import PropTypes from "prop-types";
import React from "react";
import { TextField as OutlinedInput } from "@mui/material";

import CustomTooltip from "../Others/tooltip";

import { HelpBorderless } from "../../Assets/Icons";

const TextField = React.forwardRef(
  (
    {
      className = "",
      label,
      description,
      errorMessage,
      helperText,
      tooltipContent,
      id: idProp,
      inputProps = {},
      ...props
    },
    ref
  ) => {
    const generatedId = React.useId();
    const inputId = idProp || (props.name ? `tf-${props.name}` : `tf-${generatedId}`);
    const descriptionId = description ? `${inputId}-description` : undefined;
    const errorId = errorMessage ? `${inputId}-error` : undefined;
    const helperId = helperText ? `${inputId}-helper` : undefined;
    const describedBy = [descriptionId, errorId, helperId].filter(Boolean).join(" ") || undefined;

    return (
      <div className={`text-field ${className}`}>
        {!!label && (
          <label htmlFor={inputId}>
            {label}
            {!!tooltipContent && (
              <CustomTooltip title={tooltipContent} placement="right">
                <button className="helper-tooltip" type="button" aria-label={typeof tooltipContent === "string" ? tooltipContent : "More information"}>
                  <HelpBorderless />
                </button>
              </CustomTooltip>
            )}
          </label>
        )}
        {!!description && <span className="description" id={descriptionId}>{description}</span>}
        <div className="input-icon-wrapper">
          <OutlinedInput
            fullWidth
            variant="outlined"
            id={inputId}
            inputProps={{
              ...(describedBy ? { "aria-describedby": describedBy } : {}),
              ...(!label && props.placeholder ? { "aria-label": props.placeholder } : {}),
              ...inputProps,
            }}
            {...props}
            inputRef={ref}
          />
        </div>
        {!!errorMessage && <span className="error-message" id={errorId}>{errorMessage}</span>}
        {!!helperText && <span className="helper-text" id={helperId}>{helperText}</span>}
      </div>
    );
  }
);

TextField.prototype = {
  className: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
};

export default TextField;
